<script>
import api from '@/helpers/api'

export default {
  name: 'file-preview',
  props: {
    file: { type: Object },
    width: {
      type: String,
      default: '125px'
    },
    height: {
      type: String,
      default: '125px'
    }
  },
  data () {
    return {
      previewUrl: null,
      isLoading: false
    }
  },
  async mounted () {
    if (!this.file && !this.file.id) return
    try {
      this.isLoading = true
      let { url } = await api.files.download_url({
        file_id: this.file.id
      })
      this.previewUrl = url
      this.isLoading = false
    } catch (error) {
      console.error(error)
      this.isLoading = false
    }
  },
  computed: {
    isImage () {
      return this.file && this.file.type.match('image.*')
    }
  }
}
</script>
<template>
  <div
    :style="{
      backgroundImage: `url(${previewUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center top',
      height,
      width
    }"
    v-if="isImage"
  >
    <g-overlay :show="isLoading" class="rounded-sm"></g-overlay>
  </div>
  <div
    class="avatar-lg d-flex align-items-center justify-content-center fa-2x text-secondary border bg-light"
    v-else
  >
    <g-file-icon :content-type="file.type" />
  </div>
</template>
